<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Aliquota Iva"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <v-btn text link @click="goToNew" :disabled="isLicenseBlocked">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
    </template>
    <template v-slot:content>
      <div class="d-flex justify-center align-center mb-2" style="width: 100%">
        <AdvancedFilter
          style="width:99%; height: 100%"
          v-model="filtersValue"
          :filters="filterTypes"
          :external-filter="externalFilter"
          @apply-filters="applyFilters"
        >
          <template v-slot:chip-custom-description="{filter}">
            Descrizione: {{ filter.value }}
          </template>

        </AdvancedFilter>
      </div>
      <div 
        :style="{
          'height': $vuetify.breakpoint.smAndDown ? '81%' : '86%', 
          'overflow-y': 'hidden'
        }" 
        ref="dataTableWrapper"
      >
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento aliquota iva..."
          :headers="headers"
          :loading="loading"
          :items="filteredTaxes"
          :page.sync="page"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          :show-select="false"
          single-select
          @edit="handleEdit"
          @delete="handleDelete"
        >
        </TypeDataTable>
      </div>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import AdvancedFilter from "@/components/common/AdvancedFilter.vue";
import taxesService from '@/services/taxes/taxes.service.js'

export default {
  name: "TaxesList",
  components: {
    FullScreenDialog,
    AdvancedFilter,
    TypeDataTable,
    StandardMenu
  },
  data: function() {
    let props = this.$router.resolve({name: 'Payments'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      taxes: [],
      headers: [],
      page: 1,
      rowPerPage: 20,
      totalPages: 0,
      resizeListener: undefined,
      filterTypes: [
        { type: 'date', operator: 'between', field: 'createdAt', name: 'Data Creazione', label: 'Del giorno', color: "", value: [undefined, undefined] },
        { type: 'number', operator: 'equal', field: 'value', name: 'Valore', label: 'Valore', color: "", value: undefined },
      ],
      externalFilter: { type: 'custom', operator: 'custom', field: 'description', name: 'Descrizione', label: 'Descrizione', color: "", value: undefined },
      filtersValue: [],
      isLicenseBlocked: undefined
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.filtersValue = this.filters
    this.fetchTaxes()
    
    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchTaxes() {
      let filters = [...this.filtersValue]
      this.loadingItems = true
      taxesService.list(this.page, this.rowPerPage, filters).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(this.totalPages < this.page && this.totalPages != 0) {
          this.page = this.totalPages
        }

        this.taxes = results.rows
        this.loadingItems = false
      })
    },
    applyFilters() {
      this.fetchTaxes();
    },
    fetchHeaders() {
      this.loadingHeaders = true
      taxesService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(tax) {
      this.$router.push({
        name: 'TaxesEditForm',
        params: {
          id: tax.id,
          filters: this.filtersValue
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'TaxesList'}).href,
          pathName: "TaxesList"
        }
      })
    },
    handleDelete(tax) {
      let confirmed = confirm('Sei sicuro di voler eliminare l\' aliquota iva?')

      if(confirmed) {
        this.loading
        taxesService.delete(tax).then(() => {
          this.fetchTaxes()
          this.loading
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'TaxesNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'TaxesList'}).href
        }
      })
    }
  },
  computed: {
    filteredTaxes() {
      return this.taxes
    },
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchTaxes()
    },
    rowPerPage() {
      this.fetchTaxes()
    },
  },
  isLicenseBlocked: {
    bind: 'isLicenseBlocked'
  }
}
</script>